/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum OrganizationRawMaterialAttributeKey {
  P_H = "pH",
  APPEARANCE = "appearance",
  FORM = "form",
  COLOR = "color",
  ODOR = "odor",
  FREEZING_POINT = "freezing_point",
  MELTING_POINT = "melting_point",
  SOLUBILITY = "solubility",
  VISCOSITY = "viscosity",
  HLB_VALUE = "hlb_value",
  RELATIVE_DENSITY = "relative_density",
  SURFACE_TENSION = "surface_tension",
  FUNCTION = "function",
  SHELF_LIFE = "shelf_life",
  REFRIGERATION_NEEDED = "refrigeration_needed",
  RECOMMENDED_USAGE_LEVEL = "recommended_usage_level",
  FORMULATION_TIPS = "formulation_tips",
  APPLICATIONS = "applications",
  COMPATIBILITIES = "compatibilities",
  BENEFITS = "benefits",
  CLINICAL_TESTS = "clinical_tests",
  ANTIOXIDANTS_FREE = "antioxidants_free",
  BENZENE_FREE = "benzene_free",
  BHA_FREE = "bha_free",
  BHT_FREE = "bht_free",
  BPA_FREE = "bpa_free",
  GMO_FREE = "gmo_free",
  VEGAN = "vegan",
  HALAL = "halal",
  KOSHER = "kosher",
  NOT_ANIMAL_DERIVED = "not_animal_derived",
  NOT_ANIMAL_TESTED = "not_animal_tested",
  CHINA_COMPLIANT = "china_compliant",
  REACH_COMPLIANT = "reach_compliant",
  CMR_FREE = "cmr_free",
  GLUTEN_FREE = "gluten_free",
  NANOPARTICLES_FREE = "nanoparticles_free",
  PALM_OIL_FREE = "palm_oil_free",
  PARABEN_FREE = "paraben_free",
  PHTHALATES_FREE = "phthalates_free",
  SULFATE_FREE = "sulfate_free",
  ISO16128_PCT_NATURAL_CONTENT = "iso16128_pct_natural_content",
  ISO16128_PCT_ORGANIC_CONTENT = "iso16128_pct_organic_content",
  ISO16128_PCT_NATURAL_ORIGIN = "iso16128_pct_natural_origin",
  ISO16128_PCT_ORGANIC_ORIGIN = "iso16128_pct_organic_origin",
  BSE_TSE_FREE = "bse_tse_free",
  SVHC_FREE = "svhc_free",
  PESTICIDE_FREE = "pesticide_free",
  NANOMATERIAL_FREE = "nanomaterial_free",
  MICROPARTICLE_FREE = "microparticle_free",
  MICROPLASTICS_FREE = "microplastics_free",
  BIODEGRADABILITY_STATUS = "biodegradability_status",
  PARTICLE_SIZE = "particle_size",
  UV_ABSORPTION_SPECTRUM = "uv_absorption_spectrum",
  MANUFACTURING_PROCESS = "manufacturing_process",
  CALIFORNIA_PROP_65_STATUS = "california_prop_65_status",
  CONFLICT_MINERAL_FREE = "conflict_mineral_free",
  IRRADIATION_STATUS = "irradiation_status",
  MICROBIOLOGICAL_TESTING = "microbiological_testing",
  PALM_STATUS = "palm_status",
  PALM_RSPO_STATUS = "palm_rspo_status",
  PRESERVATIVE_FREE = "preservative_free",
  RESIDUAL_MONOMERS = "residual_monomers",
  RESIDUAL_SOLVENTS = "residual_solvents",
  VOC_FREE = "voc_free",
  ALCOHOL_FREE = "alcohol_free",
  CA_SB312 = "ca_sb312",
  CA_SB484 = "ca_sb484",
  FAIR_TRADE = "fair_trade",
  GRADE = "grade",
  MICROBEADS_FREE = "microbeads_free",
  NITROSAMINES_FREE = "nitrosamines_free",
  NUT_FREE = "nut_free",
  OIL_FREE = "oil_free",
  PFAS_FREE = "pfas_free",
  SILICONES_FREE = "silicones_free",
  SOY_FREE = "soy_free",
  SULFITE_FREE = "sulfite_free",
  TALC_FREE = "talc_free",
  ASBESTOS_FREE = "asbestos_free",
  ORGANIC = "organic",
  VEGETARIAN = "vegetarian",
  CHINA_NMPA_CODE = "china_nmpa_code",
  CITES_STATUS = "cites_status",
  PAH_FREE = "pah_free",
  FORMALDEHYDE_FREE = "formaldehyde_free",
  IFRA_STATUS = "ifra_status",
  MOAH_FREE = "moah_free",
  MOSH_FREE = "mosh_free",
}
